export function getChunkPartName(currentChunkOneBased: number): string {
  return `part_${String(currentChunkOneBased - 1).padStart(5, '0')}.bin`;
}
